import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const defaultAccount = data?.account?.find((item) => item.defaultAccount === true)
  return {
    allowLiability: defaultAccount?.allowLiability,
    liabilityLimit: defaultAccount?.liabilityLimit?.toString() ?? '',
    id: defaultAccount?.id
  }
}

const getMidPayoutLiabilityConfig = (mid: any, tokens: any) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.retrieveLiabilityMidPayoutConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
        entityId: mid,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMidPayoutLiabilityConfig }
